export default __webpack_public_path__ + "static/media/gotham-black.8a58e4d5.ttf";